import {makeAutoObservable} from "mobx";
import {ValidatedValue} from "../../helpers/validatedValue";
import Validator from "../../helpers/validator";
import {errorMessages} from "../../helpers/errorMessage";

export interface IDetailInStore {
    createDetail: () => void;
    countryImoCode: ValidatedValue<string>;
    setCountryImoCode: (imoCode: string) => void;
    name: ValidatedValue<string>;
    setName: (name: string) => void;
    street: ValidatedValue<string>;
    setStreet: (street: string) => void;
    postalCode: ValidatedValue<string>;
    setPostalCode: (postalCode: string) => void;
    city: ValidatedValue<string>;
    setCity: (city: string) => void;
    phoneNo: ValidatedValue<string>;
    setPhoneNo: (phoneNo: string) => void;
    isEditData: boolean;
    setIsEditData: (value: boolean) => void;
}

export class DetailInStore implements IDetailInStore {
    _countryImoCode: ValidatedValue<string>;
    _name: ValidatedValue<string>;
    _street: ValidatedValue<string>;
    _postalCode: ValidatedValue<string>;
    _city: ValidatedValue<string>;
    _phoneNo: ValidatedValue<string>;
    _isEditData: boolean;

    constructor() {
        makeAutoObservable(this);

        const companyValidators = [{
            name: "valueIsNotEmpty",
            fn: Validator.isNotEmpty,
            errorMessage: errorMessages.required
        }];

        this._countryImoCode = new ValidatedValue("", companyValidators);
        this._name = new ValidatedValue("", companyValidators);
        this._postalCode = new ValidatedValue("", companyValidators);
        this._city = new ValidatedValue("", companyValidators);
        this._street = new ValidatedValue("", companyValidators);
        this._phoneNo = new ValidatedValue("", companyValidators);
        this._isEditData = true;
    }

    createDetail() {
        this._countryImoCode.setValue("");
        this._name.setValue("");
        this._street.setValue("");
        this._postalCode.setValue("");
        this._city.setValue("");
        this._phoneNo.setValue("");
        this._isEditData = true;
    }

    get countryImoCode() {
        return this._countryImoCode;
    }

    setCountryImoCode(imoCode: string) {
        this._countryImoCode.setValue(imoCode);
    }

    get name() {
        return this._name;
    }

    setName(name: string) {
        this._name.setValue(name);
    }

    get street() {
        return this._street;
    }

    setStreet(street: string) {
        this._street.setValue(street);
    }

    get postalCode() {
        return this._postalCode;
    }

    setPostalCode(postalCode: string) {
        this._postalCode.setValue(postalCode);
    }

    get city() {
        return this._city;
    }

    setCity(city: string) {
        this._city.setValue(city);
    }

    get phoneNo() {
        return this._phoneNo;
    }

    setPhoneNo(phoneNo: string) {
        this._phoneNo.setValue(phoneNo);
    }

    get isEditData() {
        return this._isEditData;
    }

    setIsEditData(value: boolean) {
        this._isEditData = value;
    }
}
